import React from 'react';
import { Modal } from 'react-bootstrap';

import GearSpecListContainer from '../containers/GearSpecListContainer.jsx';
import GearSpecEditContainer from '../containers/GearSpecEditContainer.jsx';

export default class GearSpecsComponent extends React.Component {

	componentDidMount() {
	}

	render() {
		return (
			<div>
				<h4>料號管理</h4>
				<GearSpecListContainer />
				<Modal show={this.props.showModal} onHide={this.props.closeModal} backdrop="static">
					<Modal.Header closeButton />
					<Modal.Body>
						<GearSpecEditContainer />
					</Modal.Body>
				</Modal>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/GearSpecsComponent.jsx